<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form inline class="search-header" :model="searchData">
      <el-form-item label="关键字" class="kw">
        <el-input
          placeholder="请输入"
          v-model="searchData.keywordValue"
          class="input-with-select"
          size="small"
        >
          <el-select
            v-model="searchData.keywordName"
            slot="prepend"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="流转时间">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.transferTimeRange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select
          style="width: 180px"
          v-model="searchData.orderStatusList"
          placeholder="请选择"
          size="small"
          multiple
          clearable
        >
          <el-option
            v-for="item in orderStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否特批">
        <el-select v-model="searchData.isForceApprove" placeholder="请选择" size="small" clearable>
          <el-option label="否" :value="false"></el-option>
          <el-option label="是" :value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机构资方">
        <SelectCapitalOrg v-model="searchData.capitalOrgCodeList" multiple />
      </el-form-item>
      <el-form-item label="">
        <el-button
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
          >搜索</el-button
        >
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <div class="export-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-upload2"
        @click="dataImportVisible = true"
        >数据导入</el-button
      >
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="downloadExcel"
        style="margin-left: 10px"
        >导出</el-button
      >
    </div>

    <tp-table
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 数据导入组件 -->
    <DataImport
      :visible.sync="dataImportVisible"
      import-type="debt"
      template-url="/static/债转状态模板.xlsx"
      template-file-name="债转状态模板.xlsx"
      @success="handleImportSuccess"
    />

    <!-- 跟进记录组件 -->
    <FollowUpRecord
      :visible.sync="followUpRecordVisible"
      :order-info="currentOrder"
      :show-add-form="true"
      submit-button-text="提交"
      @success="handleFollowUpSuccess"
    />

    <!-- 订单流转组件 -->
    <OrderTransfer
      :visible.sync="orderTransferVisible"
      :order-no="currentOrderNo"
      :menu-type="4"
      @success="handleTransferSuccess"
    />

    <!-- 完成债转确认对话框 -->
    <el-dialog
      title="完成债转"
      :visible.sync="completeDebtTransferVisible"
      width="500px"
    >
      <el-form ref="completeDebtTransferForm" :model="completeDebtTransferForm">
        <el-form-item label="备注" prop="flowContent">
          <el-input
            type="textarea"
            :rows="4"
            v-model="completeDebtTransferForm.flowContent"
            placeholder="请输入备注（可选）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="completeDebtTransferVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCompleteDebtTransfer">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderDetailRouteName } from "@/utils/order-detail-route";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getAfterSaleOrderListAPI,
  exportAfterSaleOrderAPI,
} from "../api/after-sale-order";
import { submitTransferAPI } from "../api/transfer";
import {
  EnumAfterSaleActionType,
  EnumAfterSaleMenuType,
  AfterSaleMenuTypeToFileNameMap,
} from "@/enum/dict/afterSaleOrder";
import { dateFormat } from "@/utils/index.js";
import DataImport from "../components/data-import.vue";
import FollowUpRecord from "../components/follow-up-record.vue";
import OrderTransfer from "../components/order-transfer.vue";
import { getAfterSaleOrderColumns } from "../utils/columns";
import SelectCapitalOrg from "@/views/components/select-capital-org.vue";

// 操作列定义
const operationColumn = {
  label: "操作",
  minWidth: "250",
  fixed: "right",
  customRender(h, row) {
    return (
      <div>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleOrderDetail(row)}
        >
          订单详情
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleOrderBill(row)}
        >
          账单
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleContractDetail(row)}
        >
          合同凭证
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleTransfer(row)}
        >
          移交
        </el-link>
        <el-link
          underline={false}
          type="primary"
          style="margin-right: 10px"
          onClick={() => this.handleFollowUpRecord(row)}
        >
          跟进记录
        </el-link>
        <el-link
          underline={false}
          type="primary"
          onClick={() => this.handleCompleteDebtTransferDialog(row)}
        >
          完成债转
        </el-link>
      </div>
    );
  },
};

// 使用共用的表格列定义
const columns = getAfterSaleOrderColumns(operationColumn);

export default {
  name: "DebtTransfer",
  mixins: [authBtnMixin],
  components: {
    DataImport,
    FollowUpRecord,
    OrderTransfer,
    SelectCapitalOrg,
  },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordName: "memberName",
        keywordValue: "",
        transferTimeRange: [],
        orderStatusList: [],
        isForceApprove: null,
        capitalOrgCodeList: [],
      },
      searchTypeOptions: [
        { name: "订单号", value: "orderNo" },
        { name: "客户姓名", value: "memberName" },
        { name: "手机号", value: "memberMobile" },
      ],
      orderStatusOptions: [
        { label: "租赁中", value: "6" },
        { label: "逾期中", value: "7" },
        { label: "待买断", value: "8" },
        { label: "已完成", value: "91" },
      ],
      dataImportVisible: false,
      followUpRecordVisible: false,
      orderTransferVisible: false,
      completeDebtTransferVisible: false,
      currentOrder: null,
      currentOrderNo: "",
      completeDebtTransferForm: {
        flowContent: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    buildParams(isExport = false, defaultParams = {}) {
      const params = {
        ...defaultParams,
        orderStatusList: isExport ? this.searchData.orderStatusList : this.searchData.orderStatusList.join(","),
        isForceApprove: this.searchData.isForceApprove,
        capitalOrgCodeList: isExport ? this.searchData.capitalOrgCodeList : this.searchData.capitalOrgCodeList.join(","),
      };

      // 处理关键字搜索
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }

      // 处理流转日期范围
      if (this.searchData.transferTimeRange) {
        params.leftFlowDate = this.searchData.transferTimeRange[0];
        params.rightFlowDate = this.searchData.transferTimeRange[1];
      }

      return params;
    },
    async getList() {
      const params = this.buildParams(false, {
        page: this.currentPage,
        pageSize: this.pageSize,
        menuType: EnumAfterSaleMenuType.DEBT_TRANSFER,
      });

      const res = await getAfterSaleOrderListAPI(params);

      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      this.searchData = {
        keywordName: "memberName",
        keywordValue: "",
        orderNo: "",
        transferTimeRange: [],
        orderStatusList: [],
        isForceApprove: null,
        capitalOrgCodeList: [],
      };
      this.currentPage = 1;
      this.getList();
    },
    handleOrderDetail(row) {
      const link = this.$router.resolve({
        name: getOrderDetailRouteName(row.order?.createTime),
        params: { id: row.order?.orderNo },
        query: {
          memberId: row.member?.id,
          orderType: row.order?.orderType,
        },
      });
      window.open(link.href, "_blank");
    },
    handleOrderBill(row) {
      const link = this.$router.resolve({
        name: "OrderBill",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleContractDetail(row) {
      const link = this.$router.resolve({
        name: "OrderContractDetail",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleFollowUpRecord(row) {
      this.currentOrder = row;
      this.followUpRecordVisible = true;
    },
    handleTransfer(row) {
      this.currentOrderNo = row.order?.orderNo || "";
      this.orderTransferVisible = true;
    },
    handleCompleteDebtTransferDialog(row) {
      this.currentOrderNo = row.order?.orderNo || "";
      this.completeDebtTransferForm.flowContent = "";
      this.completeDebtTransferVisible = true;
      this.$nextTick(() => {
        if (this.$refs.completeDebtTransferForm) {
          this.$refs.completeDebtTransferForm.clearValidate();
        }
      });
    },
    async handleCompleteDebtTransfer() {
      await submitTransferAPI({
        orderNo: this.currentOrderNo,
        actionType: EnumAfterSaleActionType.DEBT_COMPLETED,
        flowContent: this.completeDebtTransferForm.flowContent || "",
      });

      this.$message.success("完成债转成功");

      this.completeDebtTransferVisible = false;

      this.getList();
    },
    handleImportSuccess() {
      this.getList();
    },
    handleFollowUpSuccess() {
      this.getList();
    },
    handleTransferSuccess() {
      this.getList();
    },
    async downloadExcel() {
      const params = this.buildParams(true, {
        menuType: EnumAfterSaleMenuType.DEBT_TRANSFER,
      });

      const fileName = `OK租机${AfterSaleMenuTypeToFileNameMap.get(EnumAfterSaleMenuType.DEBT_TRANSFER)}${dateFormat()}.xlsx`;

      exportAfterSaleOrderAPI(params, fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
}

.search-header {
  .kw {
    ::v-deep {
      .input-with-select {
        vertical-align: middle;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    }
  }
}

.export-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
